import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import React from "react";

export interface StatusProps extends React.HTMLAttributes<HTMLDivElement> {
  enabled: boolean;
  enabledText?: string;
  disabledText?: string;
}

export const Status = React.forwardRef<HTMLDivElement, StatusProps>(
  (
    {
      enabled,
      enabledText = "Connected",
      disabledText = "Available",
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={cn("flex items-center gap-1.5", className)}
        {...props}
      >
        <div
          className={cn(
            "relative w-2 h-2 rounded-full",
            enabled ? "bg-lc-active" : "bg-neutral-400",
          )}
        >
          {enabled && (
            <motion.div
              className="absolute inset-0 bg-lc-active rounded-full"
              animate={{
                scale: [1, 1.8, 1],
                opacity: [0.7, 0, 0.7],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          )}
        </div>
        <span
          className={cn(
            "font-medium",
            enabled
              ? "text-lc-active dark:text-lc-active"
              : "text-muted-foreground",
          )}
        >
          {enabled ? enabledText : disabledText}
        </span>
      </div>
    );
  },
);

Status.displayName = "Status";
